/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { CacheType, createObservableDataAction, IAction, IActionContext, IActionInput } from '@msdyn365-commerce/core';
import { dXC_GetCountryMasterAsync } from '../generated/DataActionExtension.g';
import { IDXC_GetCountryMasterResponse } from '../generated/DataServiceEntities.g';

/**
 * GetStockistsCountryInput class
 */
export class GetStockistsCountryRegionsInput implements IActionInput {

    public getCacheKey = () => `StockistsCountryRegionInfo`;
    public getCacheObjectType = () => 'StockistsCountryRegionInfo';
    public dataCacheType = (): CacheType => 'request';
}

/**
 * Creates the input required to make the retail api call
 */
const createInput = (args: GetStockistsCountryRegionsInput): IActionInput => {
    return args;
};

export async function getStockcistsCountryRegionsAction(input: GetStockistsCountryRegionsInput, ctx: IActionContext)
    : Promise<IDXC_GetCountryMasterResponse> {
        console.log(`country action called`);
        let result: IDXC_GetCountryMasterResponse = { Result: 'failure' };
        try {
        result = await dXC_GetCountryMasterAsync(
            { callerContext: ctx }
        );
    } catch (error) {
        console.log(error);
    }
        return Array.isArray(result) ? result[0] : result;
}

export const IGetStockcistsCountryRegionsAction = createObservableDataAction({
    action: <IAction<IDXC_GetCountryMasterResponse>>getStockcistsCountryRegionsAction,
    input: createInput
});
